<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6 text-center">
        <img class="w-100" src="../../../assets/img/error/connection_error.svg">
        <h4 class="pt-3">{{'CONNECTION_ERROR_TITLE' | translate}}</h4>
        <p class="pt-1 error-text-label">{{'CONNECTION_ERROR_SUBTITLE' | translate}}</p>
        <div class="mx-auto">
          <button class="btn btn-primary-green mr-1" type="button" (click)="back()">{{'COMMON_BUTTON_BACK' | translate}}</button>
          <button class="btn btn-primary-green" type="button" (click)="home()">{{'MENU_NAVBAR_MENU_MAIN' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
